import React from 'react';
import { History } from 'history';
import { Input, InputDate, InputMoney, InputMultiline, InputSwitch, InputPicklist, InputFile } from '../../components';
import BaseEdit from '../base/base-edit.component'; 
import Model from './transactionpayment-model';  //editable..
import MedialibraryModel from '../medialibrary/medialibrary-model';
import PaymenttypePicklist from '../paymenttype/paymenttype-picklist.component';

interface IProps { 
    history: History;
    caption?: string;
    viewMode?: string;
}

interface IState {
    datarow: Model;
    datarowMedia: any;
    errors: any;

}

export default class TransactionpaymentEdit extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            datarow: Model.defaultValue(),
            datarowMedia: null,
            errors: null,
        }
        
        this.onChange = this.onChange.bind(this);
    }
    
    private onLoad = (data: any) => {
        this.setState({datarow:  data});
    }

    private onLoadPaymenttype = (data: any) => {
        this.setState({ datarow: { ...this.state.datarow, 'paymenttype': data?.id, 'paymenttypeCaption': data?.name || ''}  });
    }

    private onLoadFile = (data: any) => {
        this.setState({datarowMedia: {...this.state.datarowMedia, endPoint: MedialibraryModel.endPoint, endPointDelete: MedialibraryModel.endPoint2, datarow:{id:this.state.datarow.imageId, files: data, ref: Model.endPointMedia, field:'image'}}});
    }

    private onError = (data: any) => {
        this.setState({errors: data});
    }
    
    private onChange(fieldName: string, value?: string) { 
        const nextState = {
            ...this.state, datarow: {
                ...this.state.datarow, [fieldName]: value,
            }
        }
        this.setState(nextState);
    }

    render() {
        return (
            //editable..
            <BaseEdit history={this.props.history} caption={this.props.caption} 
                model={Model} datarow={this.state.datarow} datarowMedia={this.state.datarowMedia} onLoad={this.onLoad} onError={this.onError}>              
                
                {this.props.viewMode !== 'upload' &&
                <>
                <InputSwitch name='status' label='Status' value={this.state.datarow.status} options={Model.optionStatus} error={this.state.errors?.status} onChange={this.onChange}/>
                <Input name='name' label='Name' value={this.state.datarow.name} error={this.state.errors?.name} onChange={this.onChange} />
                <InputMultiline name='description' label='Description' value={this.state.datarow.description} error={this.state.errors?.description} onChange={this.onChange} />
                <InputDate name='paymentdate' label='Date' value={this.state.datarow.paymentdate} error={this.state.errors?.paymentdate} onChange={this.onChange} />
                </>
                }
                <InputPicklist name='paymenttype' label='Type' value={this.state.datarow.paymenttype} caption={this.state.datarow.paymenttypeCaption} error={this.state.errors?.paymenttype} onChange={this.onChange} >
                    <PaymenttypePicklist currentId={this.state.datarow.paymenttype} onLoad={this.onLoadPaymenttype}/>
                </InputPicklist>                 
                <InputFile name='imageUrl' label='Upload Proof of Payment' value={this.state.datarow.imageUrl} type='image' onLoad={this.onLoadFile} error={this.state.errors?.image} onChange={this.onChange} />
                {this.props.viewMode !== 'upload' &&
                <InputMoney name='value' label='Value' value={this.state.datarow.value} error={this.state.errors?.value} onChange={this.onChange} />
                }      
            </BaseEdit>
        );
    }
}